export function disableScroll(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;
}

export function enableScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}
